module.exports = __webpack_public_path__ + "img/banner-@1x.69fd40e1.jpg";